import { Descriptions, Tooltip } from 'antd'
import { useState, useMemo, useEffect } from 'react'
import { FileTextOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import { procurementTypeEnum } from '../config'

import ProductListTable from '../../../components/ProductListTable'
import service from '../../../@services'
export const amountStyle = {
  textAlign: 'right',
  margin: '20px 0',
  fontSize: '16px'
}
const otherColumns = [
  {
    title: '数量',
    dataIndex: 'quantity'
  },
  {
    title: (
      <Tooltip title='当前进货成本价'>
        <div>
          <span style={{ marginRight: '6px' }}>成本价</span>
          <ExclamationCircleOutlined style={{ fontSize: '12px' }} />
        </div>
      </Tooltip>
    ),
    dataIndex: 'costPrice'
  },
  {
    title: '成本总额',
    dataIndex: 'totalAmount'
  }
]
const returnLastColums = [
  {
    title: '数量',
    dataIndex: 'quantity'
  },
  {
    title: (
      <Tooltip title='默认取最近一次采购成本价'>
        <div>
          <span style={{ marginRight: '6px' }}>参考成本价</span>
          <ExclamationCircleOutlined style={{ fontSize: '12px' }} />
        </div>
      </Tooltip>
    ),
    dataIndex: 'refCostPrice'
  },
  {
    title: '退款单价（元）',
    dataIndex: 'costPrice'
  },
  {
    title: '退款总金额（元）',
    dataIndex: 'totalAmount',
    key: 'totalAmount'
  }
]
const basicDescs = [
  {
    title: '付款状态',
    key: 'fundStatusName'
    // formate: val => fundStatusMap[val].key
  },
  {
    title: '采购类型',
    key: 'purchaseTypeName'
  },
  {
    title: '经手人',
    key: 'operator'
  },
  {
    title: '创建时间',
    key: 'createTime'
  },
  {
    title: '备注',
    key: 'remark'
  }
]
const colorStyle = { color: '#FA4B54' }
export default function ProcurementDetail({
  procurementDetail = {},
  extendColumns = []
}) {
  const [loading, setLoading] = useState(false)
  const [pageData, setPageData] = useState({
    pageIndex: 1,
    pageSize: 10,
    result: []
  })
  const { isForReturn } = useMemo(
    () => ({
      isForReturn: procurementDetail.purchaseType == procurementTypeEnum[1]
    }),
    [procurementDetail]
  )
  const titleNode = (
    <>
      <FileTextOutlined />
      <span style={{ marginLeft: '8px' }}>
        {isForReturn ? '采购退货' : '采购销售'}单号：
        {procurementDetail.purchaseOrderNo}
      </span>
    </>
  )
  const getProductList = async (params = {}) => {
    setLoading(true)
    try {
      let _listdata = await service[
        !isForReturn ? 'purchaseOrder' : 'purchaseReturn'
      ].getDetailProductList({
        purchaseOrderNo: procurementDetail.purchaseOrderNo,
        pageSize: params.pageSize || pageData.pageSize,
        pageIndex: params.pageIndex || pageData.pageSize,
        merchantCode: procurementDetail.merchantCode,
        total: procurementDetail.total
      })
      _listdata && setPageData(_listdata)
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }
  useEffect(() => {
    if (procurementDetail.purchaseOrderNo) getProductList({ pageIndex: 1 })
    return () => {}
  }, [procurementDetail])
  return (
    // <Modal
    //   visible={showModal}
    //   title={isForReturn ? '退货单详情' : '采购单详情'}
    //   width={800}
    //   footer={
    //     <Button type='primary' onClick={() => setShowModal(false)}>
    //       确定
    //     </Button>
    //   }
    //   onCancel={() => setShowModal(false)}>
    <>
      <Descriptions title={titleNode}>
        <Descriptions.Item label='所属供应商'>
          {procurementDetail.supplierName}
        </Descriptions.Item>
        <Descriptions.Item label={isForReturn ? '退货单状态' : '采购单状态'}>
          {procurementDetail.purchaseStatusName}
        </Descriptions.Item>
        {basicDescs.map((item, index) => (
          <Descriptions.Item key={index + 'basic'} label={item.title}>
            {procurementDetail[item.key]}
          </Descriptions.Item>
        ))}
      </Descriptions>
      <ProductListTable
        isForReturn={isForReturn}
        loading={loading}
        getList={getProductList}
        otherColumns={
          extendColumns.length > 0
            ? extendColumns
            : isForReturn
            ? returnLastColums
            : otherColumns
        }
        pageData={pageData}
      />

      {!isForReturn ? (
        <div style={amountStyle}>
          共 <span style={colorStyle}>{procurementDetail.total}</span>{' '}
          种商品，采购数量{' '}
          <span style={colorStyle}>{procurementDetail.totalQuantity}</span>{' '}
          成本总额：{' '}
          <span style={colorStyle}>{procurementDetail.totalAmount}</span> 元
        </div>
      ) : (
        <div style={amountStyle}>
          共 <span style={colorStyle}>{procurementDetail.total}</span>{' '}
          种商品，出库数量{' '}
          <span style={colorStyle}>{procurementDetail.totalQuantity}</span>{' '}
          总退款金额：{' '}
          <span style={colorStyle}>{procurementDetail.totalAmount}</span> 元
        </div>
      )}
    </>
    // </Modal>
  )
}
